export default __webpack_public_path__ + "static/media/confirm_email.14508da4.svg";